'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var tooltip = require('../utils/tooltip.js');
var constants = require('./constants.js');

var generateSeriesData = function (data, names, colors) {
    return data.map(function (datum, i) { return ({
        name: names[i],
        y: datum,
        color: colors[i],
    }); });
};
var generateSeries = function (data, outerRadius, innerRadius) {
    return [
        {
            type: 'pie',
            size: outerRadius + "%",
            innerSize: innerRadius + "%",
            showInLegend: true,
            dataLabels: {
                enabled: false,
            },
            data: data,
        },
    ];
};
var getLegendOptions = function (fontFamily, legendSize) {
    var fontSize;
    var symbolHeight = 10;
    var symbolRadius = 5;
    var itemMarginBottom = 0;
    if (legendSize === 'large') {
        symbolHeight = undefined;
        symbolRadius = undefined;
        itemMarginBottom = undefined;
    }
    else if (legendSize === 'small') {
        fontSize = '11px';
    }
    else {
        fontSize = '15px';
    }
    return tslib.__assign(tslib.__assign({}, constants.legend), { itemStyle: tslib.__assign(tslib.__assign({}, constants.legend.itemStyle), { fontSize: fontSize, fontFamily: fontFamily }), symbolHeight: symbolHeight,
        symbolRadius: symbolRadius,
        itemMarginBottom: itemMarginBottom });
};
var generateOptions = function (innerRadius, outerRadius, height, values, titles, colors, legendSize, fontFamily, tooltipFormatter) {
    var legend = getLegendOptions(fontFamily, legendSize);
    var seriesData = generateSeriesData(values, titles, colors);
    var series = generateSeries(seriesData, outerRadius, innerRadius);
    return {
        title: { text: '' },
        chart: { height: height },
        legend: legend,
        series: series,
        credits: {
            enabled: false,
        },
        tooltip: {
            formatter: function () {
                return tooltip.xOnlyChart(this, tooltipFormatter);
            },
        },
    };
};

exports.generateOptions = generateOptions;
exports.generateSeries = generateSeries;
exports.generateSeriesData = generateSeriesData;
